// extracted by mini-css-extract-plugin
export default {"sizeFix":"_b48m39","collectionDescription":"_1qchdfj"};